// Angular
import { Directive, OnInit, PLATFORM_ID, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';

/**
 * Directive to the element that we want to skip while rendering on the server 
 * @example Add `*appShellNoRender` to skip element 
 * @export
 * @class AppShellNoRenderDirective
 * @implements {OnInit}
 */
@Directive({ selector: '[appShellNoRender]' })
export class AppShellNoRenderDirective implements OnInit {
    private platformId = inject<Object>(PLATFORM_ID);
    private templateRef = inject<TemplateRef<any>>(TemplateRef);
    private viewContainer = inject(ViewContainerRef);


    /**
     * On Init
     * @memberof AppShellNoRenderDirective
     */
    ngOnInit() {
        if (isPlatformServer(this.platformId)) {
            this.viewContainer.clear();
        } else {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
